import React from 'react';
import Footer from './Footer';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import '../../assets/admin/dashboard/css/sb-admin-2.min.css';
import '../../assets/admin/dashboard/css/style.css';
import '../../assets/admin/dashboard/vendor/fontawesome-free/css/all.min.css';
//import '../../assets/admin/css/jquery-selectBox/selectBox.css';
import 'bootstrap/dist/css/bootstrap.css';

import { Redirect, Route, Switch } from 'react-router-dom';
import Routes from '../../routes/admin/Routes';

const MasterLayout = () => {
    return (
        <div id="page-top-admin">
            <div id="wrapper">
                <Sidebar />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Navbar />
                        <main>
                            <Switch>
                                {Routes.map((route, idx) => {
                                    return (
                                        route.component && (
                                            <Route
                                                key={idx}
                                                path={route.path}
                                                exact={route.exact}
                                                name={route.name}
                                                render={(props) => (
                                                    <route.component {...props} />
                                                )}
                                            />
                                        )
                                    )
                                })}
                                <Redirect from="/admin" to="/admin/dashboard" />
                            </Switch>
                        </main>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    )
}
export default MasterLayout;